import React from "react";

const COLUMNS = [
    {key: "year", label: "상각년도", align: "left", width: "24%"},
    {key: "annual", label: "년차구분", align: "left", width: "14%"},
    {key: "amount", label: "감가상각비", align: "right", width: "20%"},
    {key: "accumulated", label: "감가상각 누계액", align: "right", width: "21%"},
    {key: "remain", label: "장부 자산가치", align: "right", width: "21%"},
];

function formatYearCell(value) {
    if (value == null || value === "") return "\u00A0";
    const text = String(value);
    return text.includes(" ") ? text.split(" ")[0] : text;
}

function DepreciationCalcTable({rows}) {
    const data = Array.isArray(rows) ? rows : [];

    if (data.length === 0) {
        return (
            <div className="asset-detail-calc-empty" role="status">
                계산 결과가 없습니다. 기본정보를 입력하면 자동으로 계산됩니다.
            </div>
        );
    }

    return (
        <table className="asset-detail-calc-table">
            <colgroup>
                {COLUMNS.map((col) => (
                    <col key={col.key} style={{width: col.width}} />
                ))}
            </colgroup>
            <thead>
                <tr>
                    {COLUMNS.map((col) => (
                        <th key={col.key} className={`asset-detail-calc-th is-${col.align}`}>
                            {col.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((row, index) => (
                    <tr key={row.year ?? index}>
                        {COLUMNS.map((col) => {
                            const raw = row[col.key];
                            const display =
                                col.key === "year" ? formatYearCell(raw) : raw == null ? "\u00A0" : String(raw);
                            return (
                                <td
                                    key={col.key}
                                    className={`asset-detail-calc-td is-${col.align}${
                                        col.key === "annual" ? " is-annual" : ""
                                    }`}
                                >
                                    {display}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default DepreciationCalcTable;
